import { Outlet, Navigate } from "react-router-dom";
import useAppContext from "../hooks/useAppContext";
import Banner from '../components/Banner'
import Spinner from "../components/Spinner";
import Header from "../components/Header";
import ContactoRRSS from "../components/ContactoRRSS";
import Footer from "../components/Footer";

const RutaProtegida = () => {
    const { objTramites, isLoading } = useAppContext();
  return (
    <>
    <Header />
    {isLoading && <Spinner />}
      <Banner />
      {objTramites.codTipoTipificacion ? <Outlet/> : <Navigate to="/"/>}
      <ContactoRRSS />
      <Footer />
    </>
  );
};

export default RutaProtegida;
